import api from '../../../connections/api';
import routes_api from '../../../connections/routes_api';

// ##### CLUSTERS

// GET CLUSTERS
export const getClusters = async () => {
  const response = await api.get(routes_api.notepad_clusters);
  return response.data;
};

// CREATE CLUSTER
export const createCluster = async (data) => {
  try {
    const response = await api.post(routes_api.notepad_clusters, data);
    return response.data;
  } catch (error) {
    console.error('Failed to create cluster:', error.response?.data || error.message);
    throw error;
  }
};

// UPDATE CLUSTER
export const updateCluster = async (id, data) => {
  try {
    const response = await api.patch(`${routes_api.notepad_clusters}${id}/`, data);
    return response.data;
  } catch (error) {
    console.error('Failed to update cluster:', error.response?.data || error.message);
    throw error;
  }
};

// DELETE CLUSTER
export const deleteCluster = async (id) => {
  try {
    await api.delete(`${routes_api.notepad_clusters}${id}/`);
  } catch (error) {
    console.error('Failed to delete cluster:', error.response?.data || error.message);
    throw error;
  }
};

// ##### NOTES

// GET NOTES
export const getNotes = async () => {
  const response = await api.get(routes_api.notepad_notes);
  return response.data;
};

// CREATE NOTE
export const createNote = async (data) => {
  try {
    const response = await api.post(routes_api.notepad_notes, data);
    return response.data;
  } catch (error) {
    console.error('Failed to create note:', error.response?.data || error.message);
    throw error;
  }
};

// UPDATE NOTE
export const updateNote = async (id, data) => {
  try {
    const response = await api.put(`${routes_api.notepad_notes}${id}/`, data);
    return response.data;
  } catch (error) {
    console.error('Failed to update note:', error.response?.data || error.message);
    throw error;
  }
};

// DELETE NOTE
export const deleteNote = async (id) => {
  try {
    await api.delete(`${routes_api.notepad_notes}${id}/`);
  } catch (error) {
    console.error('Failed to delete note:', error.response?.data || error.message);
    throw error;
  }
};
